import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/views/components/RadioButton.module.scss';

import { useTooltip } from '../../hooks';

export default function RadioButton({
  name,
  label,
  value,
  checked,
  onChange,
  buttonExtraStyles,
  tooltip,
  isDisabled,
}) {
  useTooltip();
  const handleOnClick = useCallback(() => {
    if (!isDisabled) {
      onChange(value);
    }
  }, [isDisabled, onChange, value]);

  return (
    <div className={styles.container} data-tip={tooltip}>
      <div onClick={handleOnClick} className={`${styles.button} ${isDisabled ? styles.disabledButton : ''}`} style={buttonExtraStyles}>
        <input className={`${styles.input} ${isDisabled ? styles.disabledInput : ''}`} checked={checked} value={value} type="radio" name={name} onChange={onChange} />
        <div className={`${styles.circle} ${isDisabled ? styles.disabledCircle : ''}`} />
        <span>{label}</span>
      </div>
    </div>
  );
}

RadioButton.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  checked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  buttonExtraStyles: PropTypes.object,
};

RadioButton.defaultProps = {
  name: '',
  label: '',
  value: '',
  checked: false,
  isDisabled: false,
  onChange: () => {},
  buttonExtraStyles: {},
};
